import styled from 'styled-components';

interface AnchorStyledProps {
  fullWidth: boolean;
}

const AnchorStyled = styled.a<AnchorStyledProps>`
  border-radius: 12px;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  padding: 15px;
  text-transform: ${({ theme }) => theme.titleTransform};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};
  outline: none;
  cursor: pointer;
  align-items: center;
  justify-content: center;

  &.primary {
    color: ${({ theme }) => theme.white};
    border: 1px solid ${({ theme }) => theme.buttonPrimaryColor};
    background-color: ${({ theme }) => theme.buttonPrimaryColor};
  }

  &.secondary {
    color: ${({ theme }) => theme.buttonPrimaryColor};
    border: 1px solid ${({ theme }) => theme.buttonPrimaryColor};
    background-color: transparent;
  }

  &.text {
    font-weight: normal;
    background-color: transparent;
    color: ${({ theme }) => theme.buttonPrimaryColor};
    border: none;
  }
`;

export default AnchorStyled;
export { AnchorStyled };
